import { Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from "@angular/material/sort";
import { ServiceRequestsService } from 'src/app/services/service-requests.service';
import { AgenciesService } from 'src/app/services/agencies.service';
import { ServiceDefService } from 'src/app/services/servicedef.service';
import { Settings } from 'src/app/services/settings';
import { SearchQBE } from 'src/app/models/searchqbe';
import { DwUtils } from 'src/app/components/utils/dw-utils';
import { ValidationResult } from 'src/app/models/validation-result';
import { CaseStatus } from 'src/app/models/case-status';
import { CasesService } from 'src/app/services/cases.service';

export class dataRecord {
	id: string;
	description: string;
	constructor(id: string, desc: string) {
		this.id = id;
		this.description = desc;
	}
}

@Component({
	selector: 'app-globalsearch-cases',
	templateUrl: './globalsearch-cases.component.html',
	styleUrls: ['./globalsearch-cases.component.css']
})
export class GlobalsearchCasesComponent implements OnInit {

	maxWarn;
	public strErr: string;
	public usersList: any;
	public searchQBE: SearchQBE = new SearchQBE();
	public disabledFlag: boolean | null = false;
	public dataSource: MatTableDataSource<any>;
	public customerRecords: any;
	public selectedRecords: any;
	public statusList: any;
	public enableSubmit: boolean | null = false;
	public selected: any;
	public records: any;
	public pagination: string;
	public Idx: number | null = -1;
	public busyCursor = false;
	public noRecordsReturned: boolean = false
	public _requestTypes: any;
	public requestTypeDataSource: any;
	public useDateRecs: any;
	public caseStatusList: CaseStatus[];

	showUnlimitedAgencyfilter = false;
	showRestrictedAgencyfilter = false;
	showPossibleDuplicated = false;
	showDateOfBirth = false;
	showDateOfBirthInList = false;
	public displayedColumns = [];

	@Output() cancelClicked = new EventEmitter();
	@Output() submitClicked = new EventEmitter<any>();
	@ViewChild(MatSort, { static: true }) sort: MatSort;
	constructor(public serviceRequestsService: ServiceRequestsService, public agenciesService: AgenciesService, private casesService: CasesService) {
		this.records = [];
		this.strErr = '';
		this.maxWarn = '';
		this.setUseDateDataSource();
		this.searchQBE.recordLimit = Settings.getInstance().GlobalSearchResultLimitCases;
	}

	public doInitialize(): void {
		//this.initializeQueryParams();
		this.noRecordsReturned = false;
		DwUtils.setFocus('memberNameParamId');

	}
	public initializeQueryParams(): void {
		this.searchQBE = new SearchQBE();
		this.searchQBE.recordLimit = Settings.getInstance().GlobalSearchResultLimitCases;
	}

	ngOnInit() {
		//this.queryCustomers();
		this.setPagination(0, 0);
		this.statusList = new Array();
		this.showDateOfBirth = Settings.getInstance().hasPrivilege('CLIENTS_GLOBAL_SEARCH_DOB', "SHOW");
		this.showDateOfBirthInList = Settings.getInstance().hasPrivilege('CLIENTS_GLOBAL_SEARCH_COL_DOB', "SHOW");
		this.showUnlimitedAgencyfilter = Settings.getInstance().hasPrivilege('CLIENTS_GLOBAL_SEARCH_UNLIMITED_AGENCY_FILTER', "SHOW");
		this.showRestrictedAgencyfilter = Settings.getInstance().hasPrivilege('CLIENTS_GLOBAL_SEARCH_ASSIGNED_AGENCY_FILTER', "SHOW");
		this.showPossibleDuplicated = Settings.getInstance().hasPrivilege('CLIENTS_GLOBAL_SEARCH_DUPLICATES', "SHOW");
		
		
		if(this.showDateOfBirthInList){
			this.displayedColumns = ['select', 'caseName', 'dateOfBirth', 'gender', 'agencyName', 'caseStatus', 'caseNumber', 'dateReference'];
		} else{
			this.displayedColumns = ['select', 'caseName', 'gender', 'agencyName', 'caseStatus', 'caseNumber', 'dateReference'];
		}
		this.statusList.push({ id: 'ALL', description: 'Any Status' });

	}
	@HostListener('document:keydown.enter', ['$event'])
	public onKeydownHandler(event: KeyboardEvent) {
		this.searchButtonClicked();
	}
	clearWindow() {
		this.clearSearchFields();
		this.records = [];
		this.strErr = '';
		this.setUseDateDataSource();
		this.doInitialize();
		this.initializeQueryParams();
		this.setPagination(0, 0);
		this.statusList = new Array();
		this.statusList.push({ id: 'ALL', description: 'Any Status' });
		this.dataSource = new MatTableDataSource(this.records);
		this.statusList.forEach(status => {
			status.isSelected = false;
		});
	}
	public loadStickyData(){
		if (Settings.getInstance().GlobalSearchQBECases) {
			this.searchQBE = Settings.getInstance().GlobalSearchQBECases;
		}
		for(let status of this.caseStatusList){
			for(let storedStatus of this.searchQBE.caseStatusList){
			if(status.shortDescription===storedStatus){
				status.isSelected = true;
			}
		}	
		}
		this.records = Settings.getInstance().GlobalSearchResultCases;
		this.dataSource = new MatTableDataSource(this.records);
	}
	public onShowHandler() {
		//this.clearWindow();

		this.usersList = Settings.getInstance().usersList;
		this.casesService.getAllCaseStatuses().subscribe(
			(result) => {
				this.caseStatusList = result;
				/** set Open to be selected **/
				/** try {
					const cIdx = this.caseStatusList.findIndex(s => s.shortDescription === 'Open');
					this.caseStatusList[cIdx].isSelected = true;

				} catch {} **/
				Settings.getInstance().caseStatusList = result;
				this.serviceRequestsService.getAllServiceRequestTypes().subscribe(
					(result2) => {
						this._requestTypes = result;
						Settings.getInstance().serviceRequestTypesList = result2;
						this.requestTypeDataSource = [];
						for (let rec of this._requestTypes) {
							this.requestTypeDataSource.push(new dataRecord(rec.description, rec.description));
						}
						this.loadStickyData();
					},
					(error2) => {
						Settings.getInstance().handleError('Error: unable to retrieve request types from the service');
						this.busyCursor = false;
					}
				);

			},
			(error1) => {
				Settings.getInstance().handleError('Error: unable to retrieve case statuses from the service');
				this.busyCursor = false;
			}
		);
	}
	public setUseDateDataSource(): void {
		this.useDateRecs = [];
		this.useDateRecs.push(new dataRecord('created', 'Submit Date'));
		this.useDateRecs.push(new dataRecord('completed', 'Completed Date'));
		this.useDateRecs.push(new dataRecord('lastModified', 'Last Touched Date'));

	}
	public onSortChange(event: any) {
		if (this.dataSource === undefined || this.records === undefined) {
			return;
		}
		try {
			const propComparator = (a: any, b: any) => {
				const propA = this.getPropertyValue(a[event.active]);
				const propB = this.getPropertyValue(b[event.active]);

				if (typeof propA === 'number' && typeof propB === 'number') {
					return event.direction === 'asc' ? propA - propB : propB - propA;
				} else if (propA instanceof Date && propB instanceof Date) {
					return event.direction === 'asc' ? propA.getTime() - propB.getTime() : propB.getTime() - propA.getTime();
				} else {
					const propAStr = propA.toString();
					const propBStr = propB.toString();
					return event.direction === 'asc' ? propAStr.localeCompare(propBStr) : propBStr.localeCompare(propAStr);
				}
			};

			this.records.sort(propComparator);
			this.dataSource.data = this.records;
			this.selectRow();
			this.setPagination(this.Idx, this.dataSource.filteredData.length);
		} catch (e) {
			console.log(e)
		}
	}
	public getPropertyValue(value: any): any {
		// Handle special cases for specific data types (e.g., date)
		// Add more cases as needed based on the data types
		if (value instanceof Date) {
			return value;
		} else {
			return typeof value === 'number' ? value : value ?? '';
		}
	};
	public toggleAllSelected(event): void {

		if (this.dataSource === undefined) {
			return;
		}

		for (const item of this.dataSource.filteredData) {
			item.select = event.checked;
		}

		if (event.checked === true) {
			this.enableSubmit = true;
		}
	}
	public runChecked(event: any): void {

		if (event.checked === true) {
			this.enableSubmit = true;
		}
		else {
			this.dataSource.filteredData.filter(x => x.select === true).length > 1 ? this.enableSubmit = true : this.enableSubmit = false;
		}
	}
	public onItemStatusChange(event: any): void {

		//this.formingQBE.itemStatusParam = event.value;
	}
	public selectRow() {
		this.Idx = this.dataSource.filteredData.findIndex(s => s.id === this.selected.id);
	}
	public onRowClicked(row: any): void {
		this.Idx = this.dataSource.filteredData.findIndex(s => s.id === row.id);
		this.selected = this.dataSource.filteredData[this.Idx];
		this.setPagination(this.Idx, this.records.length);
	}
	public setPagination(idx: number, total: number) {
		if (idx === -1) {
			this.pagination = 'No results';
		}
		this.pagination = (idx + 1) + '/' + total;
	}
	public tableKeyDown(event: KeyboardEvent) {

		const len: number = this.dataSource.filteredData.length;
		if (event.key === 'ArrowDown') {
			if (this.Idx < (len - 1)) {
				this.selected = this.dataSource.filteredData[++this.Idx];
			}
		} else if (event.key === 'ArrowUp') {
			if (this.Idx > 0) {
				this.selected = this.dataSource.filteredData[--this.Idx];
			}
		}
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
	}

	public dateCheck(inpStr: string): boolean {

		return DwUtils.chkValidDate(inpStr, true);

	}
	public searchButtonClicked(): void {

		this.noRecordsReturned = false;
		this.maxWarn = '';

		if (this.validateSearchFields() === false) {
			this.strErr = "Error: at least one piece of information is required to start the search";
			DwUtils.setFocus('memberNameParamId');
			return;
		}
		if (!this.dateCheck(this.searchQBE.memberDateAdded)) {
			this.strErr = 'Error: Invalid format for Date Added - use format (YYYY-MM-DD)'
			DwUtils.highlightFocus('dateAddedId');
			return;
		}
		if (!this.dateCheck(this.searchQBE.memberDateOfBirth)) {
			this.strErr = 'Error: Invalid format for Date of Birth - use format (YYYY-MM-DD)'
			DwUtils.highlightFocus('memberDateOfBirthId');
			return;
		}
		// Date validation
		if (this.searchQBE.dateFrom.length > 0 || this.searchQBE.dateTo.length > 0) {
			if (this.searchQBE.dateFrom.length === 0 || this.searchQBE.dateTo.length === 0) {
				this.strErr = 'Warning: Please enter both Date From and Date To.';
				return;
			}
			if (!this.dateCheck(this.searchQBE.dateFrom)) {
				this.strErr = 'Error: Invalid format for Date From - use format (YYYY-MM-DD)';
				DwUtils.highlightFocus('dateFromId');
				return;
			}
			if (!this.dateCheck(this.searchQBE.dateTo)) {
				this.strErr = 'Error: Invalid format for Date To - use format (YYYY-MM-DD)';
				DwUtils.highlightFocus('dateToId');
				return;
			}
			if (new Date(this.searchQBE.dateFrom) > new Date(this.searchQBE.dateTo)) {
				this.strErr = 'Error: Start Date cannot be later than End Date.';
				DwUtils.highlightFocus('dateFromId');
				return;
			}
		}

		this.searchQBE.caseStatusList = this.caseStatusList.filter(status => status.isSelected).map(status => status.shortDescription);

		this.strErr = '';
		this.records = [];
		this.Idx = -1;
		this.dataSource = new MatTableDataSource(this.records);
		this.busyCursor = true;
		this.casesService.searchCases(this.searchQBE).subscribe(
			(results) => {
				if (results.length === 0) {
					this.noRecordsReturned = true;
				}
				if (results.length === this.searchQBE.recordLimit) {
					this.maxWarn = 'WARNING: Maximum number of records returned (' + this.searchQBE.recordLimit + ')';
				}
				this.records = results;
				for (const rec of this.records) {
					rec.caseName = rec.firstName + ' ' + rec.lastName;
					rec.agencyName = this.getAgencyName(rec.agencyId);
				}
				this.dataSource = new MatTableDataSource(this.records);
				this.setPagination(this.Idx, this.dataSource.filteredData.length);
				this.busyCursor = false;
				Settings.getInstance().GlobalSearchQBECases = this.searchQBE;
				Settings.getInstance().GlobalSearchResultCases = this.records;
			},
			(error) => {
				Settings.getInstance().handleError(error, 'Search by parameters');
			}
		);
	}
	public getAgencyName(agencyId: number) {
		return Settings.getInstance().getAgencyName(agencyId);
	}
	public resetQueryCriteria(): void {
		this.clearSearchFields();
		this.maxWarn = '';
		this.Idx = -1;
		this.noRecordsReturned = false;
		this.records = new Array();
		this.dataSource = new MatTableDataSource<any>();
		this.strErr = '';
		this.busyCursor = false;
		this.setPagination(this.Idx, this.records.length);

		DwUtils.setFocus('memberNameParamId');
	}
	public validateSearchFields(): boolean {

		let minFieldsSelected = false;

		try {

			if (this.searchQBE.firstName.length > 0) { minFieldsSelected = true; }
			if (this.searchQBE.lastName.length > 0) { minFieldsSelected = true; }
			if (this.searchQBE.memberFirstName.length > 0) { minFieldsSelected = true; }
			if (this.searchQBE.memberLastName.length > 0) { minFieldsSelected = true; }
			if (this.searchQBE.memberDateOfBirth.length > 0) { minFieldsSelected = true; }
			if (this.searchQBE.memberRelationship.length > 0) { minFieldsSelected = true; }
			if (this.searchQBE.memberDateAdded.length > 0) { minFieldsSelected = true; }
			if (this.searchQBE.caseNumber.length > 0) { minFieldsSelected = true; }
			if (this.searchQBE.agencyName.length > 0) { minFieldsSelected = true; }
			if (this.searchQBE.phoneNumber.length > 0) { minFieldsSelected = true; }
			if (this.searchQBE.dateFrom.length > 0) { minFieldsSelected = true; }
			if (this.searchQBE.dateTo.length > 0) { minFieldsSelected = true; }
			if (this.caseStatusList.filter(s => s.isSelected === true).length > 0) { minFieldsSelected = true; }

			// Check if the "Possible Duplicates" checkbox is checked
			if (this.searchQBE.showPossibleDuplicates === true) {
				minFieldsSelected = true;
			}
		}
		catch { }

		return minFieldsSelected;
	}
	public clearSearchFields(): void {
		this.initializeQueryParams();
	}
	public onSubmitClicked(): void {
		this.selectedRecords = new Array();
		this.selectedRecords = this.dataSource.filteredData.filter(x => x.select === true);
		this.submitClicked.emit(this.selectedRecords);
	}
	public onCancelClicked(): void {
		this.cancelClicked.emit();
	}

	public lblShowDate(inp: string): string {

		const ret = DwUtils.formatReadableStringNoDay(inp);
		return ret;
	}

}
